import { useCallback } from 'react';
import { useFetcher } from '@remix-run/react';
import { COMMENT_MARK_AS_UNREAD_API_ROUTE } from '~/routes/remix-api.app.build-hub-comment-mark-as-unread';

/**
 * Hook to mark a document's comments as unread from a specific comment onwards.
 * Returns a function that can be called with a document ID and optional comment ID.
 */
export function useCommentMarkAsUnread() {
    const fetcher = useFetcher();

    const markAsUnread = useCallback(
        (documentID: string, commentID?: string) => {
            const formData = new FormData();
            formData.append('documentID', documentID);
            if (commentID) {
                formData.append('commentID', commentID);
            }

            fetcher.submit(formData, {
                method: 'post',
                action: COMMENT_MARK_AS_UNREAD_API_ROUTE,
            });
        },
        [fetcher]
    );

    return {
        markAsUnread,
        loading: fetcher.state !== 'idle',
    };
}
